import { ILaboratoryNotFoundTranslation } from 'pages/LaboratoryNotFound';

export const laboratoryNotFoundPage: ILaboratoryNotFoundTranslation = {
  title: 'Umm... Looks like you are not connected with any laboratory',
  subTitle:
    'If you are laboratory admin then you can set up laboratory now, or ask your laboratory admin to invite you.',
  laboratorySetupButton: 'Laboratory Setup',
};
